import { get } from "../utils/http.util";

const BASE_URL = process.env.REACT_APP_SCROLL_API_URL ?? "https://dev-api.scroll.degenfatcats.com/v1";

export const getScroll = async (Authorization = '', communityId: string, walletId:string) => {
    const url = `${BASE_URL}/communities/${communityId}/scrolls?walletId=${walletId}`;
    const response = await get(url, { Authorization });
    return response?.payload;
}